<script>
import AbstractForm from "./modals/abstractForm.vue";
import PastConferences from "./pastConferences.vue";
import { getDateRange } from "../../helpers/dates";
import { imgUrl } from "../../helpers/imgUrl";

export default {
  components: { AbstractForm, PastConferences },
  created() {
    this.$store.dispatch("fetchConferences");
  },
  computed: {
    conferencesList() {
      return this.$store.getters.conferences;
    },
    conference() {
      return this.conferencesList[0] || {};
    },
    conferences() {
      if (this.conferencesList.length > 0) {
        const cons = [...this.conferencesList];
        cons.shift();
        return cons;
      }
      return [];
    },
    getDates() {
      if (!this.conference.start_date) return "";
      return getDateRange(this.conference.start_date, this.conference.end_date);
    },
    truncated() {
      var str = this.conference.description;
      if (str && str.length > 1) {
        return str.slice(0, 180) + " ...";
      }
      return "";
    },
    conferenceImgSrc() {
      const v = this.conference.visual;
      if (!v) return null;
      const url = v.formats?.large?.url || v.formats?.medium?.url || v.url;
      return imgUrl({ url });
    },
  },
};
</script>

<template>
  <div v-if="conferencesList.length === 0" class="text-center py-5 d-flex flex-column align-items-center justify-content-center" style="min-height: 400px;">
  </div>

  <template v-else>
    <section class="carousel d-flex justify-content-center">
      <div class="row justify-content-around slide" v-if="conference.title">
        <div class="slide-info">
          <div>
            <h1 class="mb-2">{{ conference.title }}</h1>
            <h3 class="">Theme: {{ conference.theme }}</h3>
            <h4 class="mb-0">{{ getDates }}</h4>
            <p v-if="conference.description">
              {{ truncated }}
            </p>
          </div>
          <router-link :to="`/conference/${conference.slug}`">
            <button class="primary">Read More</button>
          </router-link>
        </div>
        <div class="slide-shadow"></div>
        <div class="slide-img">
          <img v-if="conferenceImgSrc" :src="conferenceImgSrc" alt="" loading="eager" />
        </div>
      </div>
    </section>

    <PastConferences v-bind:conferences="conferences" />
    <AbstractForm v-bind:conference="conference.id" />
  </template>
</template>
